function nap_product_slider() {
    var product_slider = new Swiper('.nap-related-products .related-products .swiper', {
        autoHeight: true,
        calculateHeight: false,
        slidesPerView: 3,
        watchOverflow: false,
        slideToClickedSlide: false,
        spaceBetween: 0,
        loop: false,
        speed: 1000,
        draggable: true,

        breakpoints: {
            1440: {
                slidesPerView: 3,
            },
            1366: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 2.7,
            },
            992: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 2,
            },
            640: {
                slidesPerView: 1.5,
            },
            550: {
                slidesPerView: 1.2,
            },
            360: {
                slidesPerView: 1,
            },
            340: {
                slidesPerView: 0.9,
            },
            300: {
                slidesPerView: 0.8,
            }
        }
    });
}
document.addEventListener("DOMContentLoaded", function () {
  nap_product_slider();
});

[
  "shopify:section:load",
  "shopify:section:unload",
  "shopify:section:select",
  "shopify:section:deselect",
  "shopify:block:select",
  "shopify:block:deselect"
].forEach(function(eventName) {
  document.addEventListener(eventName, function () {
    nap_product_slider();
  });
});